import { render, staticRenderFns } from "./KESfPagination.vue?vue&type=template&id=0c003173&"
import script from "./KESfPagination.vue?vue&type=script&lang=js&"
export * from "./KESfPagination.vue?vue&type=script&lang=js&"
import style0 from "./KESfPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsChevronLeft16px: require('/var/www/packages/theme/components/icons/chevron-left/ChevronLeft16px.vue').default,IconsChevronRight16px: require('/var/www/packages/theme/components/icons/chevron-right/ChevronRight16px.vue').default})
